module.exports = __webpack_public_path__ + "img/group125.eebe66ea.png";